import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'dgx-components-youtube-player',
  templateUrl: './youtube-player.component.html',
  styleUrls: ['./youtube-player.component.scss'],
})
export class YoutubePlayerComponent {
  @ViewChild('player', { read: ElementRef }) player!: ElementRef;

  @Input()
  video!: {
    id: string;
  };

  ngOnInit() {}

  public isPlaying = false;
  constructor(private renderer: Renderer2) {}

  playVideo(id: string) {
    this.isPlaying = true;
    const iframe = this.renderer.createElement('iframe');
    iframe.setAttribute('data-testid', 'youtube-iframe');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('allow', 'autoplay');
    iframe.setAttribute('class', 'embed-responsive-item');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute(
      'src',
      'https://www.youtube.com/embed/' +
        this.video.id +
        '?rel=0&showinfo=0&autoplay=1'
    );
    this.player.nativeElement.innerHTML = '';
    this.renderer.appendChild(this.player.nativeElement, iframe);
  }
}
